import(/* webpackMode: "eager" */ "/app/src/app/company/about-us/page.tsx");
